<template>
	<div class="portfolio-preview-wrap isotop" style="position: relative">
		<div class="portfolio-listing-section box-shadow option1 active fxt-prot-cont">
			<div class="container force-style-cont">
				<div class="d-flex align-items-center">
					<div class="portfolio-listing-box current">
						<div class="portfolio-listing-icon" data-filter="*" data-value="*">
							<svg
								x="0px"
								y="0px"
								viewBox="0 0 100 100"
								style="enable-background: new 0 0 100 100"
								xml:space="preserve"
							>
								<g>
									<g>
										<path
											d="M60,37.2H38.9c-1.2,0-2.1,1-2.1,2.1v21.3c0,1.2,0.9,2.1,2.1,2.1H60c1.2,0,2.1-1,2.1-2.1V39.4C62.1,38.2,61.2,37.2,60,37.2
                           z M57.9,58.5H41.1v-17h16.8V58.5z M34.2,0H2.6C1.5,0,0,1,0,2.1V34c0,1.2,0.9,2.1,2.1,2.1c1.2,0,2.1-1,2.1-2.1V7.2l26.1,26.2
                           c0.4,0.4,1.1,0.6,1.6,0.6c0.5,0,1.2-0.2,1.6-0.6c0.8-0.9,0.8-2.1,0-3L7.7,4.3h26.5c1.2,0,2.1-1,2.1-2.1C36.3,1,35.4,0,34.2,0z
                           M92.3,4.3L66.4,30.4c-0.8,0.9-0.8,2.1,0,3c0.4,0.4,0.9,0.6,1.5,0.6c0.5,0,0.8-0.2,1.3-0.6L94.7,7.2V34c0,1.2,0.9,2.1,2.1,2.1
                           c1.2,0,2.1-1,2.1-2.1V2.1C98.9,1,98.5,0,97.4,0H65.8c-1.2,0-2.1,1-2.1,2.1c0,1.2,0.9,2.1,2.1,2.1H92.3z M97.9,63.8
                           c-1.2,0-2.1,1-2.1,2.1v27.3L69.4,66.6c-0.8-0.9-2.1-0.9-2.9,0c-0.8,0.9-0.8,2.1,0,3l25.9,26.2H66.8c-1.2,0-2.1,1-2.1,2.1
                           c0,1.2,0.9,2.1,2.1,2.1h31.1c1.2,0,2.1-1,2.1-2.1V66C100,64.8,99.1,63.8,97.9,63.8z M34.2,95.7H7.7l25.9-26.2c0.8-0.9,0.8-2.1,0-3
                           c-0.8-0.9-2.4-0.9-3.3,0L4.2,92.8V66c0-1.2-0.9-2.1-2.1-2.1c-1.2,0-2.1,1-2.1,2.1v31.9C0,99,1.5,100,2.6,100h31.6
                           c1.2,0,2.1-1,2.1-2.1C36.3,96.7,35.4,95.7,34.2,95.7z"
										></path>
									</g>
								</g>
							</svg>
							<span>All</span>
						</div>
					</div>
					<div class="portfolio-listing-box">
						<div
							class="portfolio-listing-icon"
							data-filter=".mobapp"
							data-value="mobapp"
						>
							<svg
								x="0px"
								y="0px"
								viewBox="0 0 100 100"
								style="enable-background: new 0 0 100 100"
								xml:space="preserve"
							>
								<path
									d="M64.1,62.7c-0.6-0.6-1.6-0.6-2.2,0.1l-7,7.4c-0.6,0.6-0.6,1.5,0,2.1l7,7.4c0.3,0.3,0.7,0.5,1.1,0.5c0.4,0,0.8-0.1,1.1-0.4
                     c0.6-0.6,0.7-1.6,0.1-2.2l-6-6.3l6-6.3C64.7,64.2,64.7,63.2,64.1,62.7z M83.6,70.1l-7-7.4c-0.6-0.6-1.6-0.6-2.2-0.1
                     c-0.6,0.6-0.7,1.6-0.1,2.2l6,6.3l-6,6.3c-0.6,0.6-0.6,1.6,0.1,2.2c0.3,0.3,0.7,0.4,1.1,0.4c0.4,0,0.8-0.2,1.1-0.5l7-7.4
                     C84.1,71.6,84.1,70.7,83.6,70.1z M71.4,62.4c-0.8-0.2-1.7,0.3-1.9,1.1l-3.5,14.6c-0.2,0.8,0.3,1.7,1.1,1.9c0.1,0,0.2,0,0.4,0
                     c0.7,0,1.3-0.5,1.5-1.2l3.5-14.6C72.7,63.4,72.2,62.6,71.4,62.4z M69.2,49.6c-1.2,0-2.3,0.1-3.5,0.3V30.7c1.4,0,2.6-1.2,2.6-2.6
                     v-6.8c0-1.4-1.2-2.6-2.6-2.6V7.7C65.8,3.5,62.3,0,58,0H16.9c-4.3,0-7.8,3.5-7.8,7.7v84.6c0,4.3,3.5,7.7,7.8,7.7H58
                     c4.2,0,7.7-3.4,7.7-7.6c1.1,0.2,2.3,0.3,3.5,0.3c11.9,0,21.6-9.7,21.6-21.5C90.9,59.3,81.2,49.6,69.2,49.6z M62.7,92.3
                     c0,2.6-2.1,4.6-4.7,4.6H16.9c-2.6,0-4.7-2.1-4.7-4.6V16.9h42.4c0.9,0,1.6-0.7,1.6-1.5c0-0.9-0.7-1.5-1.6-1.5H12.2V7.7
                     c0-2.6,2.1-4.6,4.7-4.6H58c2.6,0,4.7,2.1,4.7,4.6v42.9c-8.7,2.8-15.1,10.9-15.1,20.5c0,9.6,6.3,17.8,15.1,20.5V92.3z M69.2,89.6
                     c-10.2,0-18.5-8.3-18.5-18.5c0-10.2,8.3-18.5,18.5-18.5c10.2,0,18.5,8.3,18.5,18.5C87.8,81.3,79.4,89.6,69.2,89.6z M38.7,82.6
                     c-3.3,0-5.9,2.7-5.9,5.9c0,3.3,2.7,5.9,5.9,5.9c3.3,0,5.9-2.7,5.9-5.9C44.7,85.3,42,82.6,38.7,82.6z M38.7,91.4
                     c-1.6,0-2.8-1.3-2.8-2.8c0-1.6,1.3-2.8,2.8-2.8c1.6,0,2.8,1.3,2.8,2.8C41.6,90.1,40.3,91.4,38.7,91.4z M47.7,6
                     c-1.3,0-2.4,1.1-2.4,2.4c0,1.3,1.1,2.4,2.4,2.4c1.3,0,2.4-1.1,2.4-2.4C50.1,7,49,6,47.7,6z M47.7,9C47.3,9,47,8.7,47,8.3
                     c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7C48.4,8.7,48.1,9,47.7,9z"
								></path>
							</svg>
							<span>Mobile App</span>
						</div>
					</div>
					<div class="portfolio-listing-box">
						<div
							class="portfolio-listing-icon"
							data-filter=".arvrapp"
							data-value="arvrapp"
						>
							<svg
								x="0px"
								y="0px"
								viewBox="0 0 100 100"
								style="enable-background: new 0 0 100 100"
								xml:space="preserve"
							>
								<g>
									<g>
										<path
											class="st0"
											d="M50,36.7c0.9,0,1.7-0.7,1.7-1.7c0-0.9-0.7-1.7-1.7-1.7c-0.9,0-1.7,0.7-1.7,1.7C48.3,35.9,49.1,36.7,50,36.7z
                           M50,30c0.9,0,1.7-0.7,1.7-1.7s-0.7-1.7-1.7-1.7c-0.9,0-1.7,0.7-1.7,1.7S49.1,30,50,30z M36.7,28.3H30c-1.8,0-3.3,1.5-3.3,3.3v6.7
                           c0,1.8,1.5,3.3,3.3,3.3h6.7c1.8,0,3.3-1.5,3.3-3.3v-6.7C40,29.8,38.5,28.3,36.7,28.3z M30,38.3v-6.7h6.7l0,6.7H30z M63.3,41.7H70
                           c1.8,0,3.3-1.5,3.3-3.3v-6.7c0-1.8-1.5-3.3-3.3-3.3h-6.7c-1.8,0-3.3,1.5-3.3,3.3v6.7C60,40.2,61.5,41.7,63.3,41.7z M63.3,31.7H70
                           l0,6.7h-6.7V31.7z M95,81.3c-7.8-4.1-21.2-8.7-30-10.6c6.6-5.7,10.9-14.7,11.6-23.2c2.1-1.1,3.5-3.3,3.5-5.8V28.3
                           c0-3-2-5.6-4.8-6.4C71.8,10.9,62.2,0,50,0C37.8,0,28.2,10.9,24.8,21.9C22,22.7,20,25.3,20,28.3v13.3c0,2.5,1.4,4.7,3.5,5.8
                           c0.7,8.5,5,17.5,11.6,23.2c-8.9,1.9-22.2,6.5-30,10.6c-3.1,1.6-5,4.8-5,8.2v8.8c0,0.9,0.7,1.7,1.7,1.7h96.7c0.9,0,1.7-0.7,1.7-1.7
                           v-8.8C100,86.1,98.1,82.9,95,81.3z M50,3.3c10.2,0,18.2,8.9,21.6,18.3H28.4C31.8,12.2,39.8,3.3,50,3.3z M23.3,41.7V28.3
                           c0-1.7,1.3-3.1,2.9-3.3c0,0,0.1,0,0.1,0c0,0,0.3,0,0.3,0h46.6c0.1,0,0.1,0,0.2,0c0,0,0.2,0,0.2,0c0.1,0,0.1,0,0.2,0h0
                           c1.6,0.3,2.8,1.6,2.8,3.3v13.3c0,1.4-0.9,2.6-2.2,3.1c-0.1,0-0.1,0-0.2,0.1c-0.3,0.1-0.6,0.2-1,0.2H59.3c-0.8,0-1.4-0.5-1.6-1.3
                           l-0.4-1.6c-0.6-2.2-2.6-3.8-4.8-3.8h-4.8c-2.3,0-4.3,1.6-4.8,3.8l-0.4,1.6c-0.2,0.7-0.9,1.3-1.6,1.3H26.7
                           C24.8,45,23.3,43.5,23.3,41.7z M26.9,48.3h13.8c2.3,0,4.3-1.6,4.8-3.8l0.4-1.6c0.2-0.7,0.9-1.3,1.6-1.3h4.8c0.8,0,1.4,0.5,1.6,1.3
                           l0.4,1.6c0.6,2.2,2.6,3.8,4.8,3.8h13.8c-1,8.5-5.9,17.4-12.9,21.9c0,0-0.1,0-0.1,0.1l-1.1,0.6L58.8,71l-0.3,0.1
                           c-0.1,0-0.1,0.1-0.1,0.1c-2.6,1.3-5.4,2.1-8.4,2.1c-3,0-5.8-0.8-8.4-2.1c0,0-0.1-0.1-0.1-0.1L40,70.3c0,0-0.1,0-0.1-0.1
                           C32.8,65.7,27.9,56.9,26.9,48.3z M54.6,76.1l-4,5.3c-0.2,0.3-0.5,0.3-0.6,0.3c-0.1,0-0.4,0-0.6-0.3l-4-5.3c1.5,0.3,3,0.5,4.6,0.5
                           C51.6,76.7,53.1,76.5,54.6,76.1z M76.7,96.7h-10v-3.3h10V96.7z M96.7,96.7H80v-5c0-0.9-0.7-1.7-1.7-1.7H65c-0.9,0-1.7,0.7-1.7,1.7
                           v5h-60v-7.1c0-2.2,1.2-4.2,3.2-5.3c8.6-4.5,24-9.7,32.2-10.8l0.8,0.5l7.2,9.5c0.8,1,2,1.6,3.3,1.6c1.3,0,2.5-0.6,3.3-1.6l7.2-9.5
                           l0.1,0c0,0,0.1-0.1,0.1-0.1l0.6-0.3c8.2,1.2,23.6,6.3,32.2,10.8c2,1,3.2,3.1,3.2,5.3V96.7z"
										></path>
									</g>
								</g>
							</svg>
							<span>AR / VR App</span>
						</div>
					</div>
					<div class="portfolio-listing-box">
						<div
							class="portfolio-listing-icon"
							data-filter=".gameapp"
							data-value="gameapp"
						>
							<svg
								x="0px"
								y="0px"
								viewBox="0 0 100 100"
								style="enable-background: new 0 0 100 100"
								xml:space="preserve"
							>
								<path
									d="M81.1,64.9c-1-0.4-1.9-0.6-2.7-0.6c-1.1,0-1.8,0.3-2.2,0.5l-4.5-1.8c-0.3-0.8-0.9-2.3-3.6-3.4c-0.8-0.3-1.6-0.5-2.4-0.5
                     c-2.2,0-4.1,1.1-5.3,2.8l-4.9,5.9c-1.5,1.9-3.4,4.6-1.8,6.8c0.7,1,1.8,1.5,3.2,1.5c0.9,0,1.9-0.2,3.2-0.8c2.1-1,3.4-1.6,4.2-2
                     c1.3,0.6,2.9,0.4,4.1-0.5l3.3,1.4c0.2,1.4,1.1,2.7,2.6,3.2c0.3,0.9,0.8,2.3,1.6,4.4c1,2.6,2.5,3.9,4.4,3.9c0.2,0,0.4,0,0.6-0.1
                     c2.7-0.4,3.3-3.7,3.5-6.1L85,72C85.5,69,83.9,66,81.1,64.9z M81.9,71.5c0,0.1,0,0.1,0,0.2l-0.7,7.7c-0.3,2.9-0.9,3.3-0.9,3.3
                     c0,0-0.1,0-0.1,0c-0.5,0-1-0.7-1.5-1.9c0,0-1.8-4.8-1.9-5.1c-0.2-0.5-0.7-0.9-1.2-1c-0.9-0.1-0.9-0.9-0.9-1.4c0-0.7-0.3-1.3-1-1.5
                     l-5.1-2.1c-0.6-0.3-1.3-0.1-1.8,0.4c-0.2,0.3-0.6,0.6-1,0.6c-0.2,0-0.4-0.1-0.6-0.2c-0.4-0.3-1-0.4-1.4-0.2c-0.1,0-0.1,0-0.2,0.1
                     c-0.3,0.1-4.9,2.3-4.9,2.3c-1,0.4-1.5,0.5-1.9,0.5c-0.4,0-0.5-0.1-0.7-0.3c0,0-0.1-0.8,1.7-3l5-6c0,0,0.1-0.1,0.1-0.1
                     c0.9-1.3,2.6-1.9,4.1-1.3c1.4,0.6,1.7,1.1,1.9,1.7c0.2,0.5,0.5,1.2,1.4,1.6l5.1,2.1c0.3,0.1,0.5,0.2,0.8,0.2c0.5,0,0.9-0.2,1.3-0.3
                     c0.3-0.1,0.6-0.2,1-0.2c0.4,0,0.9,0.1,1.5,0.4C81.4,68.3,82.2,69.9,81.9,71.5z M80.2,70.4c0.2-0.8-0.1-1.6-0.9-1.9
                     c-0.7-0.3-1.6,0-1.9,0.7c-0.8-0.2-1.6,0.1-1.9,0.9c-0.3,0.7,0,1.6,0.7,1.9c-0.2,0.8,0.1,1.6,0.9,1.9c0.2,0.1,0.4,0.1,0.6,0.1
                     c0.6,0,1.1-0.3,1.4-0.8c0.2,0,0.3,0.1,0.5,0.1c0.6,0,1.2-0.4,1.4-0.9C81.2,71.6,80.9,70.7,80.2,70.4z M67.8,65.7l-0.2-0.1l0.1-0.2
                     c0.3-0.8-0.1-1.7-0.8-2c-0.8-0.3-1.7,0.1-2,0.8l-0.1,0.2l-0.2-0.1c-0.8-0.3-1.7,0.1-2,0.8c-0.3,0.8,0.1,1.7,0.8,2l0.2,0.1l-0.1,0.2
                     c-0.3,0.8,0.1,1.7,0.8,2c0.2,0.1,0.4,0.1,0.6,0.1c0.6,0,1.2-0.4,1.4-1l0.1-0.2l0.2,0.1c0.2,0.1,0.4,0.1,0.6,0.1c0.6,0,1.2-0.4,1.4-1
                     C69,66.9,68.6,66,67.8,65.7z M69.9,83.1c-0.9,0-1.5,0.7-1.5,1.5v7.7c0,2.6-2.1,4.6-4.6,4.6H22.7c-2.6,0-4.6-2.1-4.6-4.6V7.7
                     c0-2.6,2.1-4.6,4.6-4.6h41.1c2.6,0,4.6,2.1,4.6,4.6v41.7c0,0.9,0.7,1.5,1.5,1.5c0.9,0,1.5-0.7,1.5-1.5V28.6c1.2-0.2,2.1-1.3,2.1-2.5
                     v-6.8c0-1.2-0.9-2.3-2.1-2.5V7.7C71.5,3.5,68,0,63.7,0H22.7c-4.3,0-7.7,3.5-7.7,7.7v84.6c0,4.3,3.5,7.7,7.7,7.7h41.1
                     c4.3,0,7.7-3.5,7.7-7.7v-7.7C71.5,83.8,70.8,83.1,69.9,83.1z M50.9,7.9c0.9,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5H35.5
                     c-0.9,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5H50.9z M38.9,91.6c0,2.4,1.9,4.3,4.3,4.3c2.4,0,4.3-1.9,4.3-4.3c0-2.4-1.9-4.3-4.3-4.3
                     C40.8,87.3,38.9,89.2,38.9,91.6z M44.4,91.6c0,0.7-0.5,1.2-1.2,1.2S42,92.2,42,91.6c0-0.7,0.5-1.2,1.2-1.2S44.4,90.9,44.4,91.6z
                     M61.7,51.2c0.9,0,1.7-0.8,1.7-1.7v-28c0-3.3-2.7-5.9-5.9-5.9h-28c-3.3,0-5.9,2.7-5.9,5.9v57.6c0,3.3,2.7,5.9,5.9,5.9h20.3
                     c0.9,0,1.7-0.8,1.7-1.7c0-0.9-0.8-1.7-1.7-1.7H29.5c-1.4,0-2.5-1.1-2.5-2.5V21.4c0-1.4,1.1-2.5,2.5-2.5h28c1.4,0,2.5,1.1,2.5,2.5v28
                     C60,50.4,60.7,51.2,61.7,51.2z"
								></path>
							</svg>
							<span>Games</span>
						</div>
					</div>
					<div class="portfolio-listing-box">
						<div
							class="portfolio-listing-icon"
							data-filter=".websiteapp"
							data-value="websiteapp"
						>
							<svg
								x="0px"
								y="0px"
								viewBox="0 0 100 100"
								style="enable-background: new 0 0 100 100"
								xml:space="preserve"
							>
								<g>
									<g>
										<path
											class="st0"
											d="M97.4,76.9h-0.7V19.8c0-3.7-3-6.7-6.7-6.7H10c-3.7,0-6.7,3-6.7,6.7v57.1H2.6c-1.4,0-2.6,1.2-2.6,2.7v4.8
                           C0,85.8,1.2,87,2.6,87h94.7c1.5,0,2.6-1.2,2.6-2.7v-4.8C100,78.1,98.8,76.9,97.4,76.9z M6.7,19.8c0-1.9,1.5-3.4,3.3-3.4h80
                           c1.8,0,3.3,1.5,3.3,3.4v57.1H58.7L58.3,78c-0.1,0.3-0.4,0.6-0.8,0.6H44.2c-0.4,0-0.7-0.3-0.8-0.6L43,76.9H6.7V19.8z M96.7,83.6
                           H3.3v-3.4h37.5c0.8,1,2,1.7,3.3,1.7h13.3c1.3,0,2.5-0.6,3.3-1.7h35.8V83.6z M90,71.8V21.4c0-0.9-0.7-1.7-1.7-1.7H11.7
                           c-0.9,0-1.7,0.8-1.7,1.7v50.4c0,0.9,0.7,1.7,1.7,1.7h76.7C89.3,73.5,90,72.8,90,71.8z M86.7,70.2H13.3v-47h73.3V70.2z M40,56.7
                           c0.9,0,1.7-0.8,1.7-1.7c0-0.9-0.7-1.7-1.7-1.7c-0.9,0-1.7,0.8-1.7,1.7C38.3,56,39.1,56.7,40,56.7z M32,56.1
                           c0.3,0.4,0.8,0.6,1.3,0.6c0.4,0,0.7-0.1,1-0.4c0.7-0.6,0.8-1.6,0.3-2.4l-5.8-7.3l5.8-7.4c0.6-0.7,0.5-1.8-0.3-2.4
                           c-0.7-0.6-1.8-0.5-2.3,0.3l-6.7,8.4c-0.5,0.6-0.5,1.5,0,2.1L32,56.1z M65.6,56.4c0.3,0.3,0.7,0.4,1,0.4c0.5,0,1-0.2,1.3-0.6
                           l6.7-8.4c0.5-0.6,0.5-1.5,0-2.1L68,37.2c-0.6-0.7-1.6-0.8-2.3-0.3c-0.7,0.6-0.8,1.6-0.3,2.4l5.8,7.4L65.4,54
                           C64.8,54.7,64.9,55.8,65.6,56.4z M40,50c0.9,0,1.7-0.8,1.7-1.7V38.2c0-0.9-0.7-1.7-1.7-1.7c-0.9,0-1.7,0.8-1.7,1.7v10.1
                           C38.3,49.3,39.1,50,40,50z M46.7,56.7H50c0.9,0,1.7-0.8,1.7-1.7c0-0.9-0.7-1.7-1.7-1.7h-3.3c-0.9,0-1.7,0.8-1.7,1.7
                           C45,56,45.7,56.7,46.7,56.7z M56.7,56.7H60c0.9,0,1.7-0.8,1.7-1.7c0-0.9-0.7-1.7-1.7-1.7h-3.3c-0.9,0-1.7,0.8-1.7,1.7
                           C55,56,55.7,56.7,56.7,56.7z"
										></path>
									</g>
								</g>
							</svg>
							<span>Website</span>
						</div>
					</div>
				</div>
			</div>
		</div>

		<Section v-for="item in arr" v-bind:key="item"></Section>
	</div>
</template>

<script>
import Section from './Section';

export default {
	data: () => {
		return {
			arr: [1]
		};
	},
	components: {
		Section
	}
};
</script>

<style>
.option1.portfolio-listing-section {
	top: -60px;
	position: absolute;
	z-index: 10;
	max-width: 1170px;
	width: 100%;
	margin: 0 auto;
	left: 0;
	right: 0;
	opacity: 0;
	visibility: hidden;
}
.option1.portfolio-listing-section.active {
	display: block;
	opacity: 1;
	visibility: visible;
}
.portfolio-listing-box {
	width: 20%;
	text-align: center;
	display: flex;
	align-items: center;
	-webkit-transition: all 0.3s ease-in-out;
	-moz-transition: all 0.3s ease-in-out;
	-o-transition: all 0.3s ease-in-out;
	transition: all 0.3s ease-in-out;
	border-right: 1px solid #dddfe1;
}
.option1 .portfolio-listing-box:first-child,
.option1 .portfolio-listing-box:last-child {
	border-left: 0;
}

.option1 .portfolio-listing-box.current,
.option1 .portfolio-listing-box:hover {
	background-color: #1977cc;
}
.portfolio-listing-icon {
	width: 100%;
	margin: 0 auto;
	cursor: pointer;
	min-height: 120px;
	padding: 18px 10px;
}
.portfolio-listing-icon svg {
	width: 44px;
	height: 44px;
}
.option1 .portfolio-listing-box.current .portfolio-listing-icon span,
.option1 .portfolio-listing-box.current .portfolio-listing-icon svg circle,
.option1 .portfolio-listing-box.current .portfolio-listing-icon svg ellipse,
.option1 .portfolio-listing-box.current .portfolio-listing-icon svg line,
.option1 .portfolio-listing-box.current .portfolio-listing-icon svg path,
.option1 .portfolio-listing-box.current .portfolio-listing-icon svg polygon,
.option1 .portfolio-listing-box.current .portfolio-listing-icon svg rect,
.option1 .portfolio-listing-box:hover .portfolio-listing-icon svg circle,
.option1 .portfolio-listing-box:hover .portfolio-listing-icon svg ellipse,
.option1 .portfolio-listing-box:hover .portfolio-listing-icon svg line,
.option1 .portfolio-listing-box:hover .portfolio-listing-icon svg path,
.option1 .portfolio-listing-box:hover .portfolio-listing-icon svg polygon,
.option1 .portfolio-listing-box:hover .portfolio-listing-icon svg rect {
	fill: #fff;
}
.portfolio-listing-box.current .portfolio-listing-icon span,
.portfolio-listing-box:hover .portfolio-listing-icon span {
	color: #fff;
}
.portfolio-listing-icon span {
	display: block;
	font-size: 16px;
	margin-top: 15px;
	-webkit-transition: all 0.3s ease-in-out;
	-moz-transition: all 0.3s ease-in-out;
	-o-transition: all 0.3s ease-in-out;
	transition: all 0.3s ease-in-out;
}
.option1.portfolio-listing-section .d-flex {
	border-radius: 10px;
	overflow: hidden;
	background: #fff;
}
@media (max-width: 991px) {
	.portfolio-listing-box .portfolio-listing-icon {
		padding: 10px 0;
	}
}
@media (max-width: 776px) {
	.portfolio-listing-box .portfolio-listing-icon svg {
		max-width: 30px;
		padding:0;
		font-size:10px;
	}
	.force-style-cont {
		max-width:100% !important;
		padding:0 !important;
	}
	.fxt-prot-cont {
		top:0 !important;
	}
	.portfolio-listing-box .portfolio-listing-icon span {
		font-size: 12px;
	}
	.option1.portfolio-listing-section .d-flex {
		border-radius:0 !important;
	}
}
</style>
